export class Constants {
    static Shared = class {
        static LargeScreenBreakpoint = 1264;
        static LargeLaptopScreenBreakpoint = 1440;
    };
    static Pagination = class {
        static DefaultLimit: number = 25;
    };
    static Collection = class {
        static AllCollectionsId: number = -1;
    };
    static Portal = class {
        static DefaultPortalID: number = 1;
        static MaxSystemPortalId: number = 99;
    };

    static QuillEditorOptions = class {
        static textFormatOptions = ["bold", "italic", "underline", "strike"]; // toggled buttons
        static listOptions = [{ list: "ordered" }, { list: "bullet" }];
        static indentOptions = [{ indent: "-1" }, { indent: "+1" }]; // outdent/indent
        static link = ["link"];
        static image = ["image"];
    };
    static QuillEditor = class {
        static defaultToolbarOptions = [
            Constants.QuillEditorOptions.textFormatOptions,
            Constants.QuillEditorOptions.listOptions,
            Constants.QuillEditorOptions.indentOptions,
            Constants.QuillEditorOptions.link,
            Constants.QuillEditorOptions.image
        ];
    };

    static Dashboard = class {
        static ellipsisBreakpoint = 20;
        static diagramHeight = 400;
        static subtitleFontSize = 40;
        static fontWeight = 900;
        static percentageGraphMaxValue = 100;
        static rotationAngle = 90;
        static constantLineWidth = 2;
        static constantLineDashStyle = "dash";
        static barPaddingSize = 0.01;
        static defaultTickIntervalMaxValue = 5;
        static animationDuration = 100;
        static chartHeight = 120;
        static chartWidth = 220;
        static diagramHeightPercentage = 0.75;
        static minDiagramFontSize = 9;
        static maxDiagramFontSize = 24;
        static pieChartsTopCount = 5;
    };

    static LicensedParts = class {
        static ExceededWarningDays: number = 42; // this is NOT a reference to the Hitchhiker's Guide, if you change this value keep in mind to change it on all other places (Vue projects, iProva, etc)
        static NoConnectionWithLicenseServerWarningDays: number = 42; // this is NOT a reference to the Hitchhiker's Guide, if you change this value keep in mind to change it on all other places (Vue projects, iProva, etc)
    };

    static Document = class {
        static snackbarMaxWidth: number = 672;
        static snackbarMinWidth: number = 344;
        static snackbarTextMargin: number = 40;
        static snackbarWrapperMargin: number = 16;
        static DocumentFieldId = class {
            static ChangesComparedToPreviousVersion: number = 15;
        };
    };

    static Task = class {
        static maxTaskLimit: number = 999;
        static maxNotificationLimit: number = 999;
    };
}
